<template>
    <div style="overflow: auto;">
      <div @click="navigateToFlightOperationsView()" style="cursor: pointer;">
        <b-icon icon="chevron-left" class="mt-3"></b-icon>&nbsp;Zurück
      </div>
      <b-alert variant="info" show class="text-center mt-3">
        <div>
          <b-icon icon="info-circle" font-scale="1.5"></b-icon>
          <br />
          Bitte im Vereinsflieger prüfen, ob der Gutschein gültig ist.  
          Nach dem Flugtag den Gutschein dem Vorstand übergeben oder an der Korkwand befestigen.<br /> 
          Auf dem Gutschein markieren: <strong>„abgeflogen“</strong>.
        </div>
      </b-alert>
      <div class="mt-4">
        <b-list-group>
          <b-list-group-item v-for="(guestflight, index) in filteredSortedEntries" :key="index" v-b-toggle="'collapse-' + index">
            {{ guestflight.name }} - 
            {{ guestflight.formattedDate }}
            <b-icon icon="chevron-down"></b-icon>
            <b-collapse :id="'collapse-' + index" class="mt-2">
              <b-card header="Gastflug - Informationen">
                Name: {{ guestflight.name }}<br>
                Gastflug am: {{ guestflight.formattedDate }}<br>
                <hr>
                <font-awesome-icon icon="envelope"/>&nbsp;E-Mail: <a :href="'mailto:' + guestflight.email">{{ guestflight.email }}</a><br>
                <font-awesome-icon icon="phone"/>&nbsp;Telefon: <a :href="'tel:' + guestflight.phonenumber">{{ guestflight.phonenumber }}</a><br>
                <hr>
                Gutscheinvariante: {{ guestflight.variant }}<br>
                Gutscheinnummber: {{ guestflight.number }}<br>
              </b-card>
            </b-collapse>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: "guestflightView",
    components: {},
    data() {
      return {
        guestflights: [],

        apiUrl: process.env.VUE_APP_API_URL,
      };
    },
  
    computed: {
      filteredSortedEntries() {
        const today = new Date()
        return this.guestflights
          .filter(entry => {
            const entryDate = new Date(entry.date)
            const diffTime = today - entryDate
            const diffDays = diffTime / (1000 * 60 * 60 * 24)
            return diffDays <= 2
          })
          .sort((a, b) => new Date(a.date) - new Date(b.date))
      }
    },
  
    methods: {
      navigateToFlightOperationsView() {
        this.$router.push(`/flight-operations`);
      },
    },
  
    beforeMount() {
      axios.get(this.apiUrl + '/guest-flight/get-entries')
        .then((response) => {
          this.guestflights =  this.guestflights = Object.values(response.data.entries);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
  
          if (error.status === 401) {
            localStorage.removeItem('token');
          } 
        });
    },
  };
  </script>
  
  <style scoped></style>
  